import { render, staticRenderFns } from "./anunt-2.vue?vue&type=template&id=24610f3d&scoped=true"
import script from "./anunt-2.vue?vue&type=script&lang=js"
export * from "./anunt-2.vue?vue&type=script&lang=js"
import style0 from "./anunt-2.vue?vue&type=style&index=0&id=24610f3d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24610f3d",
  null
  
)

export default component.exports